module.exports = __webpack_public_path__ + "static/img/党建.587a18a7.png";